import { Form, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { EntityDetailsFields } from 'common/components/entity-details';
import { useStore } from 'core/store';
import { ErrorAlert } from '../quote-errors';
import { offerDetailsCodes } from '../quote-forms/quote-forms.constants';

const OfferDetails = ({ sectionsToShow }) => {
  const {
    quote: { getAlerts }
  } = useStore();

  const { values } = useFormikContext();

  const alerts = getAlerts(offerDetailsCodes, values.policyType);

  return (
    <Form>
      {alerts.length > 0 && <ErrorAlert alerts={alerts} id="error-alert-offer-details" />}
      <EntityDetailsFields title="Offer Details" />
    </Form>
  );
};

OfferDetails.propTypes = {
  sectionsToShow: PropTypes.array.isRequired
};

export default OfferDetails;
